import "@/index.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { ProvedorAutenticacao, useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { RotaProtegida } from "@/componentes/RotaProtegida";

import PortalPublico from "@/paginas/PortalPublico";
import RankingPublico from "@/paginas/RankingPublico";
import Regulamento from "@/paginas/Regulamento";
import Login from "@/paginas/Login";
import AceitarRegulamento from "@/paginas/AceitarRegulamento";

import DashboardApostador from "@/paginas/DashboardApostador";
import Jogos from "@/paginas/Jogos";
import Palpitar from "@/paginas/Palpitar";
import PalpitarJogo from "@/paginas/PalpitarJogo";
import MeusPalpites from "@/paginas/MeusPalpites";
import RankingApostador from "@/paginas/RankingApostador";
import VerRegulamento from "@/paginas/VerRegulamento";

import DashboardAdmin from "@/paginas/admin/DashboardAdmin";
import GerenciarUsuarios from "@/paginas/admin/GerenciarUsuarios";
import GerenciarPagamentos from "@/paginas/admin/GerenciarPagamentos";
import GerenciarJogos from "@/paginas/admin/GerenciarJogos";
import GerenciarInformativos from "@/paginas/admin/GerenciarInformativos";
import GerenciarRegulamento from "@/paginas/admin/GerenciarRegulamento";
import ConfiguracoesSistema from "@/paginas/admin/ConfiguracoesSistema";
import LogsSistema from "@/paginas/admin/LogsSistema";

function RoteadorDashboard() {
  const { usuario } = useAutenticacao();
  if (!usuario) return <Navigate to="/login" replace />;
  if (usuario.perfil === "ADMINISTRADOR" || usuario.perfil === "SUPER_ADMIN") {
    return <Navigate to="/admin" replace />;
  }
  return <DashboardApostador />;
}

export default function App() {
  return (
    <ProvedorAutenticacao>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          {/* Públicas */}
          <Route path="/" element={<PortalPublico />} />
          <Route path="/ranking-publico" element={<RankingPublico />} />
          <Route path="/regulamento" element={<Regulamento />} />
          <Route path="/login" element={<Login />} />

          {/* Autenticadas */}
          <Route
            path="/aceitar-regulamento"
            element={
              <RotaProtegidaSemAceite>
                <AceitarRegulamento />
              </RotaProtegidaSemAceite>
            }
          />

          <Route
            path="/dashboard"
            element={
              <RotaProtegida>
                <RoteadorDashboard />
              </RotaProtegida>
            }
          />
          <Route
            path="/jogos"
            element={
              <RotaProtegida>
                <Jogos />
              </RotaProtegida>
            }
          />
          <Route
            path="/palpitar"
            element={
              <RotaProtegida perfilNecessario={["APOSTADOR"]}>
                <Palpitar />
              </RotaProtegida>
            }
          />
          <Route
            path="/palpitar/:jogoId"
            element={
              <RotaProtegida perfilNecessario={["APOSTADOR"]}>
                <PalpitarJogo />
              </RotaProtegida>
            }
          />
          <Route
            path="/meus-palpites"
            element={
              <RotaProtegida perfilNecessario={["APOSTADOR"]}>
                <MeusPalpites />
              </RotaProtegida>
            }
          />
          <Route
            path="/ranking"
            element={
              <RotaProtegida>
                <RankingApostador />
              </RotaProtegida>
            }
          />
          <Route
            path="/ver-regulamento"
            element={
              <RotaProtegida>
                <VerRegulamento />
              </RotaProtegida>
            }
          />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <DashboardAdmin />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <GerenciarUsuarios />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/pagamentos"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <GerenciarPagamentos />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/jogos"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <GerenciarJogos />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/informativos"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <GerenciarInformativos />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/regulamento"
            element={
              <RotaProtegida perfilNecessario={["SUPER_ADMIN"]}>
                <GerenciarRegulamento />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/configuracoes"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <ConfiguracoesSistema />
              </RotaProtegida>
            }
          />
          <Route
            path="/admin/logs"
            element={
              <RotaProtegida perfilNecessario={["ADMINISTRADOR", "SUPER_ADMIN"]}>
                <LogsSistema />
              </RotaProtegida>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ProvedorAutenticacao>
  );
}

function RotaProtegidaSemAceite({ children }) {
  const { usuario, carregando } = useAutenticacao();
  if (carregando) return null;
  if (!usuario) return <Navigate to="/login" replace />;
  return children;
}
